import { Component, effect, inject, input, Input, OnChanges, OnInit, signal, SimpleChanges, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox'
import { InvoiceService } from '../../../services/invoice.service';
import { InvoiceListRequest } from '../../../models/invoice.model';
import { NotificationService } from '../../../services/notificationservice';
import { LookUpService } from '../../../services/lookupservice';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NgFor, NgIf } from '@angular/common';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { FeedstockService } from '../../../services/feedstockservice';
import { FilterState, GeneratorsList, GetMarketGeneratorsResponse } from '../../../interfaces/generatorsmodel';
import { Subject, takeUntil } from 'rxjs';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertDialogComponent,AlertDialogData } from '../../shared/components/alert-dialog/alert-dialog.component';
import { json } from 'stream/consumers';
import { RolePermissionsService } from '../../../services/role-permissions.service';
import { LoadScheduleControlFlags, ScreenName } from '../../../interfaces/securityPermissions';
import { strictDateValidator, dateRangeCompleteValidator } from '../../shared/commonutils/helper';
import { SelectSearchComponent } from "../../shared/components/select-search/select-search.component";
import { MatSelectItems } from '../../../interfaces/lookup';
import { RoleService } from '../../../services/role.service';

@Component({
  selector: 'app-regularinvoice',
  standalone: true,
  imports: [MatTableModule, MatRow, MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatButtonModule, MatSelectModule, MatDatepickerModule, CommonModule,
    MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, MatCardModule, FormsModule,
    ReactiveFormsModule, MatCheckboxModule, SelectSearchComponent],
   templateUrl: './regularinvoice.component.html',
  styleUrl: './regularinvoice.component.scss'
})
export class RegularinvoiceComponent {
  permissions = inject(RolePermissionsService);
    range: FormGroup = new FormGroup({
      start: new FormControl<Date | null>(null, [strictDateValidator]),
      end: new FormControl<Date | null>(null, [strictDateValidator]),
    }, {validators: dateRangeCompleteValidator});

  private destroy$ = new Subject<void>();
  displayedColumns: string[] = ['workOrderNumber','response', 'statusCode', 'reprocess','request'];  
  dataSource = new MatTableDataSource<any>;
  workOrderNo: string = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  // filterState = input<FilterState | null>(null);
  refreshTrigger = input<number>(0);
  statusInfo: MatSelectItems[] = [];
  statusCode: string = '';
  statusData: any[] = [];
  gridSearchText = input<string | null>(null);
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();

  constructor(private _lookupService: LookUpService,private _invoiceService: InvoiceService, private dialog: MatDialog,
    private _fsService: FeedstockService, private rolesService: RoleService) {
      let roles = this.rolesService.getRolesAsString();

    this._lookupService.getStatusInfo().pipe(takeUntil(this.destroy$)).subscribe({
      next: (status: any[]) => {
        console.log('status:', status);
        this.statusData = status;
        this.statusInfo = this.statusData.map(item => ({
          id: item.id!,
          name: item.name!
        }));
      }
    })
    this.permissions.getRolePermissionsNew(roles, ScreenName.IP, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
  }

  ngOnInit(): void {
    const enddate = new Date();
    const startDate = new Date();
    startDate.setDate(enddate.getDate() - 7);
   
    this.range.controls['start'].setValue(startDate);
    this.range.controls['end'].setValue(enddate);

    this.InvoiceSearch();
  }

  onStatusReceived(event: number | null){    
    //this.direction = event;
    if (event === -1 || event === null) {
      this.statusCode = '';
    } else {
      // Find the item matching the numeric ID and extract its code
      const selectedStatus = this.statusData.find(i => i.id === event);
      this.statusCode = selectedStatus ? selectedStatus.code : '';
    }
  }

  InvoiceSearch(){
    this.range.controls['start'].markAsDirty();
    this.range.controls['start'].markAsTouched();
    this.range.controls['end'].markAsDirty();
    this.range.controls['end'].markAsTouched();
    this.range.controls['start'].updateValueAndValidity();
    this.range.controls['end'].updateValueAndValidity();
    this.range.markAllAsTouched();
    this.range.updateValueAndValidity();
    
    if(this.range.invalid){
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Invalid Date Range',
          message: 'Please select a valid date range.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    if (this.range.invalid || !this.range.value.start || !this.range.value.end) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Invalid Date Range',
          message: 'Please select a valid date range.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    var invoicerequest: InvoiceListRequest = {
      CustomerId: 0,
      StreamId: 0,
      Year: 0,
      Month:0,
      StartDate: this.range.value.start ? this.range.value.start.toISOString().slice(0, 10) : '',
      EndDate: this.range.value.end ? this.range.value.end.toISOString().slice(0, 10) : '',
      Status: this.statusCode,
      WorkOrderNumber: this.workOrderNo
    };
    console.log("input sending to IP", invoicerequest);
    this._invoiceService.getRegularInvoice(invoicerequest).pipe(takeUntil(this.destroy$)).subscribe({
      next: (invoicelistres: any[]) => {
        this.dataSource.data = invoicelistres;
      }
    });
  }

  showPayloadRequest(requestPayload: string){
    requestPayload = JSON.parse(requestPayload);
    const dialogData: AlertDialogData = {
      title: 'Payload Request',
      message:requestPayload
    };
    
    this.dialog.open(AlertDialogComponent, {
      width: '650px',
      maxWidth: '650px',
      data: dialogData,
      disableClose: true
    });
  }

  RunMonthEndProcess(){
    this._invoiceService.runMonthEndProcess().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        
      }
    });
  }
  
  ReprocessInvoice(){
    const selectedWorkOrders = this.dataSource.data
      .filter(item => item.isSelected)
      .map(item => item.workOrderNumber);

    if (selectedWorkOrders.length === 0) {
      this.dialog.open(AlertDialogComponent, {      
        data: {
          title: 'Warning',
          message: 'Please select at least one work order to reprocess.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    this._invoiceService.reprocessRegularInvoice(selectedWorkOrders).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this.InvoiceSearch();
      }
    });
  }
  onKeydown(event: KeyboardEvent) {
    if(event.ctrlKey && event.metaKey){return;} 
    if(!/[0-9\/]/.test(event.key) && event.key.length === 1){
      event.preventDefault();
    }
    setTimeout(() => {
      this.range.updateValueAndValidity();
      this.range.markAllAsTouched();
    });
  }

  dateformat(event: Event){
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if(!value) return;
    const parts = value.split('/');
    if(parts.length !== 3) return;

    let [month, day, year] = parts.map(part => part.padStart(2, '0'));
    if(month.length === 1)  month = '0' + month;
    if(day.length === 1)  day = '0' + day;
    if(year.length === 2) year = '20' + year;
    input.value = `${month}/${day}/${year}`;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
